import TasksContainer from "../../../Components/Application/Tasks/Tasks"

const Tasks = () => {
  return (
    <div className='page-body'>
      <TasksContainer />
    </div>
  )
}

export default Tasks